import {
    setCountryCount,
    setScarvesCount,
    setScarvesData,
    setContributorScarvesCount,
    setContributorsList,
} from '@redux/slices/dataSlice';

const NON_COUNTRIES_COUNT = 4;

const countScarvesByContributor = items => {
    return items.reduce((acc, category) => {
        category.scarves.forEach(scarf => {
            if (!scarf.contributor) return;

            acc[scarf.contributor] =
                (acc[scarf.contributor] || 0) + 1;
        });

        return acc;
    }, {});
};

export const getDataSuccess = dispatch => data => {
    const countriesCount =
        data.items.length - NON_COUNTRIES_COUNT;
    const scarvesCount = data.items.reduce(
        (acc, category) => acc + category.scarves.length,
        0
    );
    const scarvesByContributor = countScarvesByContributor(
        data.items
    );

    dispatch(setScarvesCount(scarvesCount));
    dispatch(setCountryCount(countriesCount));
    dispatch(setScarvesData(data.items));
    dispatch(
        setContributorScarvesCount(scarvesByContributor)
    );
};

export const getContributorsListSuccess =
    dispatch => data => {
        dispatch(setContributorsList(data));
    };
